<input
	[id]="id"
	role="switch"
	type="checkbox"
	[(ngModel)]="value"
	(change)="valueChanged()"
	hidden="hidden"
	[attr.aria-checked]="value"
/>
<label class="switch" [for]="id"></label>
